import { useSearch } from '@tanstack/react-router';
import { useState } from 'react';

import type { Window } from '../api/queries';

const DAY_MS = 86_400_000;
const DEFAULT_DAYS = 7;

export function defaultWindow(now: Date): Window {
  return {
    from: new Date(now.getTime() - DEFAULT_DAYS * DAY_MS).toISOString(),
    to: now.toISOString(),
  };
}

/** The reading window: `?from=&to=` (ISO instants) when both are present, else
 *  the last seven days, fixed at mount so the queries' keys do not move under
 *  a re-render. */
export function usePublicationWindow(): Window {
  const search = useSearch({ strict: false }) as Record<string, unknown>;
  const [fallback] = useState(() => defaultWindow(new Date()));
  const { from, to } = search;
  return typeof from === 'string' && typeof to === 'string' ? { from, to } : fallback;
}

/** `?comentarios=todos` opens the comment list in full. */
export const ALL_COMMENTS = { comentarios: 'todos' } as const;

export function useAllComments(): boolean {
  const search = useSearch({ strict: false }) as Record<string, unknown>;
  return search.comentarios === ALL_COMMENTS.comentarios;
}
